const Pagination = ({ 
  currentPage, 
  totalPages, 
  onPageChange,
  maxVisibleButtons = 5 
}) => {
  
  const handlePageChange = (pageNumber) => {
    onPageChange(pageNumber);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const renderPaginationButtons = () => {
    const buttons = [];
    
    let startPage = Math.max(1, currentPage - Math.floor(maxVisibleButtons / 2));
    let endPage = Math.min(totalPages, startPage + maxVisibleButtons - 1);
    
    if (endPage - startPage < maxVisibleButtons - 1) {
      startPage = Math.max(1, endPage - maxVisibleButtons + 1);
    }

    // Previous button
    if (currentPage > 1) {
      buttons.push(
        <button
          key="prev"
          onClick={() => handlePageChange(currentPage - 1)}
          style={styles.paginationButton}
          onMouseEnter={(e) => {
            if (currentPage !== parseInt(e.target.textContent)) {
              e.target.style.backgroundColor = '#f5f5f5';
              e.target.style.borderColor = '#999';
            }
          }}
          onMouseLeave={(e) => {
            if (currentPage !== parseInt(e.target.textContent)) {
              e.target.style.backgroundColor = '#fff';
              e.target.style.borderColor = '#ddd';
            }
          }}
        >
          ‹ Previous
        </button>
      );
    }

    // First page
    if (startPage > 1) {
      buttons.push(
        <button
          key={1}
          onClick={() => handlePageChange(1)}
          style={styles.paginationButton}
          onMouseEnter={(e) => {
            e.target.style.backgroundColor = '#f5f5f5';
            e.target.style.borderColor = '#999';
          }}
          onMouseLeave={(e) => {
            e.target.style.backgroundColor = '#fff';
            e.target.style.borderColor = '#ddd';
          }}
        >
          1
        </button>
      );
      if (startPage > 2) {
        buttons.push(<span key="dots1" style={styles.dots}>...</span>);
      }
    }

    // Page numbers
    for (let i = startPage; i <= endPage; i++) {
      buttons.push(
        <button
          key={i}
          onClick={() => handlePageChange(i)}
          style={{
            ...styles.paginationButton,
            ...(currentPage === i ? styles.activePage : {})
          }}
          onMouseEnter={(e) => {
            if (currentPage !== i) {
              e.target.style.backgroundColor = '#f5f5f5';
              e.target.style.borderColor = '#999';
            }
          }}
          onMouseLeave={(e) => {
            if (currentPage !== i) {
              e.target.style.backgroundColor = '#fff';
              e.target.style.borderColor = '#ddd';
            }
          }}
        >
          {i}
        </button>
      );
    }

    // Last page
    if (endPage < totalPages) {
      if (endPage < totalPages - 1) {
        buttons.push(<span key="dots2" style={styles.dots}>...</span>);
      }
      buttons.push(
        <button
          key={totalPages}
          onClick={() => handlePageChange(totalPages)}
          style={styles.paginationButton}
          onMouseEnter={(e) => {
            e.target.style.backgroundColor = '#f5f5f5';
            e.target.style.borderColor = '#999';
          }}
          onMouseLeave={(e) => {
            e.target.style.backgroundColor = '#fff';
            e.target.style.borderColor = '#ddd';
          }}
        >
          {totalPages}
        </button>
      );
    }

    // Next button
    if (currentPage < totalPages) {
      buttons.push(
        <button
          key="next"
          onClick={() => handlePageChange(currentPage + 1)}
          style={styles.paginationButton}
          onMouseEnter={(e) => {
            e.target.style.backgroundColor = '#f5f5f5';
            e.target.style.borderColor = '#999';
          }}
          onMouseLeave={(e) => {
            e.target.style.backgroundColor = '#fff';
            e.target.style.borderColor = '#ddd';
          }}
        >
          Next ›
        </button>
      );
    }

    return buttons;
  };

  if (totalPages <= 1) {
    return null;
  }

  return (
    <div style={styles.paginationContainer}>
      {renderPaginationButtons()}
    </div>
  );
};

const styles = {
  paginationContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    gap: "8px",
    marginTop: "40px",
    marginBottom: "20px",
    flexWrap: "wrap",
  },
  paginationButton: {
    padding: "8px 16px",
    border: "1px solid #ddd",
    borderRadius: "6px",
    backgroundColor: "#fff",
    color: "#333",
    cursor: "pointer",
    fontSize: "14px",
    fontWeight: "500",
    transition: "all 0.2s ease",
    minWidth: "40px",
  },
  activePage: {
    backgroundColor: "#3498db",
    color: "#fff",
    borderColor: "#3498db",
  },
  dots: {
    padding: "8px 4px",
    color: "#999",
  },
};

export default Pagination;